import transliterationMap from '@utils/transliterationMap';

const replacementMap: Record<string, string> = {
  ...transliterationMap,
  ' ': '-',
  '-': '-',
  '&': '-and-',
};
export const transformNameToTransliteration = (name: string) => {
  return [...name.toLowerCase()]
    .map((symbol) =>
      symbol.match(/[a-z0-9]/) ? symbol : replacementMap[symbol],
    )
    .filter(Boolean)
    .join('')
    .replace(/-+/g, '-');
};
